var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM13.5759 6.48008C13.8411 6.16187 13.7981 5.68895 13.4799 5.42378C13.1617 5.1586 12.6887 5.2016 12.4236 5.5198L8.82561 9.83735C8.48362 10.2477 8.27598 10.4942 8.10452 10.6502C8.02551 10.7221 7.97859 10.7513 7.95592 10.7627C7.94975 10.7658 7.94581 10.7674 7.94385 10.7681C7.94183 10.7676 7.93777 10.7664 7.93134 10.7638C7.90773 10.7545 7.85835 10.7296 7.77316 10.6652C7.58829 10.5254 7.35918 10.2987 6.98145 9.921L5.53006 8.46961C5.23716 8.17672 4.76229 8.17672 4.4694 8.46961C4.1765 8.7625 4.1765 9.23738 4.4694 9.53027L5.92079 10.9817L5.95426 11.0151C6.28742 11.3484 6.59041 11.6514 6.86845 11.8617C7.173 12.092 7.5447 12.2879 8.01183 12.2667C8.47896 12.2455 8.83139 12.0167 9.11384 11.7598C9.37171 11.5253 9.64601 11.196 9.94763 10.834L9.97794 10.7976L13.5759 6.48008Z",
    fill: "#197BBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBlueIcon);
export default __webpack_public_path__ + "static/media/right-blue-icon.ea1051b150ca7da2cd81ae9bf095b801.svg";
export { ForwardRef as ReactComponent };